export default {
    originatorView: {
        MustBeValidCodeOriginator: 'Must be a valid code originator',
        originatorsList: 'Lista de Originadores'
    }
};
